export const environment = {
  url: 'https://control.connect24.io',
  api_url: 'https://apiv3.connect24.io',
  data_gmaps: {
    api_key: 'AIzaSyBml8lmg4FPqa7kvOM85m0kCegKXpV8fIU',
    version: 'beta',
  },
};
